import { selectFieldTriggerTextClassName, selectFieldTriggerValueClassName } from "@patient-watch/ui/select";
import type { ReactNode } from "react";
import type { OptionT } from "../Select";

/** Mirrors Select trigger: icon (when present) plus a single-line ellipsed label. */
export function ComboBoxTriggerValue({
    selected,
    placeholder,
}: {
    selected: OptionT | undefined;
    placeholder: ReactNode;
}) {
    if (!selected) {
        return <span className={selectFieldTriggerTextClassName()}>{placeholder}</span>;
    }

    return (
        <span className={selectFieldTriggerValueClassName()}>
            {selected.icon ? <span className="[&_svg]:size-4 shrink-0">{selected.icon}</span> : null}
            <span className="min-w-0 truncate">{selected.label}</span>
        </span>
    );
}
